import { GridLocation } from "src/grid/GridLocation";
import { Instruction } from "../Instruction";
import { ProgramModel } from "../ProgramContext";

export class BranchIfEvenInstruction extends Instruction<"branch-even"> {
  readonly type = "branch-even";

  act(context: ProgramModel) {
    if (context.mana % 2 === 0) {
      context.cursorDirection = "down";
    } else {
      context.cursorDirection = "right";
    }
  }
}
